"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppRecentSection = exports.AppRecentSectionDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var section_1 = require("../elements/section");
var info_message_1 = require("../elements/info-message");
var recent_entity_list_1 = require("../entities/recent-entity-list");
var use_lang_1 = require("../../hooks/use-lang");
var use_icons_1 = require("../../hooks/use-icons");
exports.AppRecentSectionDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var RecentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.isDialog && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      max-height: 200px;\n      overflow-y: auto;\n    "], ["\n      max-height: 200px;\n      overflow-y: auto;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.isDialog && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      max-height: 600px;\n    "], ["\n      max-height: 600px;\n    "])));
  })
});
var MessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(section_1.Section)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  RecentEntities: (0, styled_components_1.default)(recent_entity_list_1.RecentEntityList)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), RecentStyles),
  EmptyMessage: (0, styled_components_1.default)(info_message_1.InfoMessage)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles)
};
var AppRecentSection = function (props) {
  var className = props.className,
    isDialog = props.isDialog,
    onItemClick = props.onItemClick,
    items = props.items;
  var hasRecentItems = items && !!items.length;
  var t = (0, use_lang_1.useLang)();
  var Icons = (0, use_icons_1.useIcons)();
  return react_1.default.createElement(My.Container, {
    icon: Icons.Entities.Unit,
    title: t('Recently Viewed'),
    className: className
  }, hasRecentItems ? react_1.default.createElement(My.RecentEntities, {
    items: items,
    onItemClick: onItemClick,
    isDialog: isDialog
  }) : react_1.default.createElement(My.EmptyMessage, null, t('No items to display - this area will show recently viewed items on this device as you browse the platform.')));
};
exports.AppRecentSection = AppRecentSection;
exports.AppRecentSection.defaultProps = exports.AppRecentSectionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;